import { ENV_TYPE } from '@shiftnex/framework/src/libs/config';

export const API_BASE_URL = import.meta.env.FE_FX_API_BASE_URL as string;
export const FEATURE_FLAG_DEPLOYMENT_KEY = import.meta.env.FE_FX_FEATURE_FLAG_DEPLOYMENT_KEY as string;
export * from '@shiftnex/framework/src/libs/config';
export const MULTIACCESS_DOMAINS =
  (import.meta.env.FE_FX_MULTIACCESS_DOMAINS as string).split(',').map((dom) => dom.trim()) || [];
export const USERPILOT_TOKEN = import.meta.env.FE_FX_USERPILOT_TOKEN as string;

// BUILD INFO
export const BUILD_INFO = {
  BUILD_MODE: import.meta.env.SYSTEM_MODE as string,
  START_MODE: window.location.hostname === 'localhost' ? 'local' : 'server',
  APP_VERSION: FE_FX_APP_VERSION as string,
  ENV_TYPE,
  WORKING_REGIONS: import.meta.env.SYSTEM_COUNTRY_REGIONS as string,
  API_BASE_URL,
  COMMIT_HASH: import.meta.env.FE_FX_LAST_COMMIT as string,
  COMMIT_DATE: import.meta.env.FE_FX_LAST_COMMIT_DATE as string,
  COMMIT_AUTHOR: import.meta.env.FE_FX_LAST_COMMIT_AUTHOR as string,
  COMMIT_MESSAGE: import.meta.env.FE_FX_LAST_COMMIT_MESSAGE as string,
  COMMIT_TAG: import.meta.env.FE_FX_LAST_COMMIT_TAG as string,
  BUILD_DATE_TIME: import.meta.env.FE_FX_APP_BUILD_TIME || 0,
  COMMIT_URL: `https://${(import.meta.env.FE_FX_REPO_GIT_ORIGIN || '').replace(':', '/').replace('https///git@', '').replace('.git', '')}/commit/${import.meta.env.FE_FX_LAST_COMMIT}`,
};

export const SPECIAL_AGENCIES = {
  ShiftnexMarketplace: import.meta.env.FE_FX_SHIFTNEX_MARKETPLACE_ID as string,
  Actriv: import.meta.env.FE_FX_ACTRIV_ID as string,
};

// Logger
export const LOG_LEVEL = import.meta.env.FE_FX_LOG_LEVEL as string;
export const LOG_ENABLED = import.meta.env.FE_FX_LOG_ENABLED as boolean;

export const TENANT_ID = (import.meta.env.FE_FX_TENANT_ID as string) || localStorage.getItem('tenant-id');
